/** Derleme sürümü (vue.config.js derleme anında yazar: "YYYY-MM-DD HH:mm (git-hash)"). */
export const APP_VERSION = process.env.VUE_APP_BUILD_VERSION || "dev";

/** Otomatik güncelleme ile yenilenmeden önce yazılan bilgi; telemetri bir kez okuyup siler. */
export const UPDATED_FROM_KEY = "brew_updated_from";
